/**
 * 全局组件
 */

// svg
import svgIcon from "./SvgIcon.vue";
// tab切换按钮
// 存放组件数组
const componentsArr = [svgIcon];

export default componentsArr;
